import React, { useState, useEffect } from "react";
import { useApp } from "../context/AppContext";
import { X, AlertTriangle } from "lucide-react";

// 标记流失对话框: 选择流失原因分类 + 可选备注, 提交后走「市场部经理复核」
export default function MarkLostDialog({ open, onClose, onConfirm }) {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const [reasons, setReasons] = useState([]);
  const [cat, setCat] = useState("");
  const [note, setNote] = useState("");
  const [competitor, setCompetitor] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) {
      setCat(""); setNote(""); setCompetitor("");
      api.get("/crm/lost-reasons").then(({ data }) => setReasons(data || [])).catch(() => setReasons([]));
    }
  }, [open]); // eslint-disable-line

  if (!open) return null;
  const submit = async () => {
    if (!cat) return;
    setBusy(true);
    try { await onConfirm({ reasonCategory: cat, reason: note.trim(), lostToCompetitor: competitor.trim() }); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4" data-testid="mark-lost-dialog">
      <div className="w-full max-w-md rounded-2xl bg-white shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-3.5 bg-rose-50 border-b border-rose-100">
          <p className="text-[15px] font-bold text-rose-700 flex items-center gap-2"><AlertTriangle className="h-4.5 w-4.5" />{zh ? "标记流失" : "Mark as Lost"}</p>
          <button onClick={onClose} data-testid="mark-lost-close" className="text-slate-400 hover:text-slate-600"><X className="h-5 w-5" /></button>
        </div>
        <div className="p-5 space-y-4">
          <p className="text-[12.5px] text-slate-500">{zh ? "客户将进入「市场部经理复核」，由市场部经理联系确认后做最终归类。请选择流失原因：" : "The lead enters MM review. Choose a churn reason:"}</p>
          <div className="grid grid-cols-2 gap-2">
            {reasons.map((r) => (
              <button key={r.key} data-testid={`lost-reason-${r.key}`} onClick={() => setCat(r.key)}
                className={`h-9 rounded-lg text-[13px] font-semibold border transition-colors ${cat === r.key ? "bg-rose-600 text-white border-rose-600" : "bg-white text-slate-600 border-slate-200 hover:border-rose-300"}`}>
                {zh ? r.zh : r.en}
              </button>
            ))}
          </div>
          <input data-testid="lost-competitor" value={competitor} onChange={(e) => setCompetitor(e.target.value)} maxLength={60}
            placeholder={zh ? "败给哪家竞品公司（选填，积累竞品胜率库供 AI 分析）" : "Lost to which competitor (optional)"}
            className="w-full text-sm rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-rose-200" />
          <textarea data-testid="lost-reason-note" value={note} onChange={(e) => setNote(e.target.value)} rows={2}
            placeholder={zh ? "补充说明(可选)" : "Optional note"}
            className="w-full text-sm rounded-lg border border-slate-200 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-rose-200" />
          <div className="flex justify-end gap-2 pt-1">
            <button onClick={onClose} className="h-9 px-4 rounded-lg text-sm font-semibold text-slate-500 hover:bg-slate-100">{zh ? "取消" : "Cancel"}</button>
            <button onClick={submit} disabled={!cat || busy} data-testid="mark-lost-confirm"
              className="h-9 px-4 rounded-lg text-sm font-bold text-white bg-rose-600 hover:bg-rose-700 disabled:opacity-40">
              {busy ? "…" : (zh ? "提交复核" : "Submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
